export default "__VITE_ASSET__K2jw2YlL__"